/* eslint-disable @angular-eslint/directive-selector */
import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';
import { PermissionsService } from '../service/permissions.service';
import { Subject, takeUntil } from 'rxjs';

@Directive({
  selector: '[hasPermission]',
  standalone: true
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  @Input('hasPermission') permission: string | string[] = '';
  @Input() hasPermissionMode: 'hide' | 'disable' = 'hide';
  
  private destroy$ = new Subject<void>();
  private originalDisplay: string = '';

  constructor(
    private el: ElementRef,
    private permissionsService: PermissionsService
  ) {
    const computedStyle = window.getComputedStyle(this.el.nativeElement);
    this.originalDisplay = computedStyle.display !== 'none' ? computedStyle.display : 'block';
  }

  ngOnInit() {
    setTimeout(() => {
      this.updateElementVisibility();
    });

    this.permissionsService.permissions$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateElementVisibility();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateElementVisibility() {
    if (!this.el?.nativeElement) return;

    const hasPermission = this.permissionsService.hasPermission(this.permission);

    if (this.hasPermissionMode === 'hide') {
      const displayValue = hasPermission ? (this.originalDisplay || 'block') : 'none';
      this.el.nativeElement.style.display = displayValue;
    } else {
      if (this.el.nativeElement instanceof HTMLButtonElement ||
          this.el.nativeElement instanceof HTMLInputElement ||
          this.el.nativeElement instanceof HTMLSelectElement ||
          this.el.nativeElement instanceof HTMLTextAreaElement) {
        this.el.nativeElement.disabled = !hasPermission;
      } else {
        if (!hasPermission) {
          this.el.nativeElement.classList.add('disabled');
          this.el.nativeElement.setAttribute('aria-disabled', 'true');
          this.el.nativeElement.style.pointerEvents = 'none';
        } else {
          this.el.nativeElement.classList.remove('disabled');
          this.el.nativeElement.removeAttribute('aria-disabled');
          this.el.nativeElement.style.pointerEvents = '';
        }
      }
    }
  }
}